export const INTERVIEWER_NAMES = [
  { id: 1, name: "최시현" },
  { id: 2, name: "최예은" },
  { id: 3, name: "윤다인" },
  { id: 4, name: "곽서연" },
  { id: 5, name: "김은혜" },
  { id: 6, name: "이은재" },
  { id: 7, name: "김동현" },
  { id: 8, name: "양성원" }
] as const;

export const DEFAULT_TIME_SLOTS = [
  "09:00 AM",
  "10:00 AM",
  "11:00 AM",
  "02:00 PM",
  "03:00 PM",
  "04:00 PM"
];
